export default {
  background: -999,
  behind: -9,
  infront: 9,
  foreground: 999,
  overlay: 99999,
};
